import { Controller } from "@hotwired/stimulus"

// Countdown timer controller for avatar upload limit dialog
// Displays remaining time in human-readable format
export default class extends Controller {
  static targets = ["display"]
  static values = {
    seconds: Number
  }

  connect() {
    this.updateDisplay()
    this.startTimer()
  }

  disconnect() {
    this.stopTimer()
  }

  startTimer() {
    this.timer = setInterval(() => {
      if (this.secondsValue > 0) {
        this.secondsValue--
        this.updateDisplay()
      } else {
        this.stopTimer()
        // Reload page using Turbo when countdown reaches zero
        import("@hotwired/turbo").then(({ Turbo }) => {
          Turbo.visit(window.location.href, { action: "replace" })
        })
      }
    }, window.BusinessConstants.UITiming.COUNTDOWN_INTERVAL_MS)
  }

  stopTimer() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  }

  updateDisplay() {
    if (this.hasDisplayTarget) {
      this.displayTarget.textContent = this.formatTime(this.secondsValue)
    }
  }

  formatTime(totalSeconds) {
    const hours = Math.floor(totalSeconds / 3600)
    const minutes = Math.floor((totalSeconds % 3600) / 60)
    const seconds = totalSeconds % 60

    // Read I18n strings from data attributes
    const i18n = {
      hours: this.element.dataset.i18nHours || '小時',
      minutes: this.element.dataset.i18nMinutes || '分鐘',
      seconds: this.element.dataset.i18nSeconds || '秒',
      suffix: this.element.dataset.i18nSuffix || '後可再次上傳'
    }

    if (hours > 0) {
      return `${hours}${i18n.hours} ${minutes}${i18n.minutes}${i18n.suffix}`
    } else if (minutes > 0) {
      return `${minutes}${i18n.minutes} ${seconds}${i18n.seconds}${i18n.suffix}`
    } else {
      return `${seconds}${i18n.seconds}${i18n.suffix}`
    }
  }
}
